<script>
export default {
  name: "MeetingVotesInformationList",

  props: {
    heightBlock: {
      type: String,
      default: '25vh'
    },

    votes: {
      type: Array,
      required: true
    }
  },

  methods: {
    votePersonFullName(vote) {
      return vote?.person_full_name || null;
    },

    voteStatus(vote) {
      return vote.payload.status
    },

    voteComment(vote) {
      return vote.payload.comment;
    }
  }
}
</script>

<template>
  <v-list class="overflow-auto" :style="{'height': heightBlock}">
    <template v-for="vote in votes">
      <v-list-item
        :key="vote.id"
      >
        <v-list-item-content>
          <v-list-item-title v-text="votePersonFullName(vote)"></v-list-item-title>
          <v-list-item-subtitle class="d-flex text-wrap">
            {{voteStatus(vote) ? 'Голосует ЗА' : voteComment(vote)}}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon :color="voteStatus(vote) ? 'teal darken-3' : 'error'" small>
            {{voteStatus(vote) ? 'fa-thumbs-up' : 'fa-thumbs-down'}}
          </v-icon>
        </v-list-item-icon>
      </v-list-item>
      <v-divider></v-divider>
    </template>
  </v-list>
</template>

<style scoped>

</style>